import { useState } from "react";

export default function Pagination({ page, setPage, total, perPage, goToPage }) {
    const totalPages = Math.ceil(total / perPage);



    return (
        <div className="df fdc aic gap1 bcgrey1 p1 cw">
            <div className="df aic gap1">
                <button
                    onClick={() => goToPage(page - 1)}
                    disabled={page == 1}
                    className="px3 py1 fm shadow disabled:opacity-40"
                >
                    Prev
                </button>

                <div className="px4 py1 fm ">
                    Page <form onSubmit={(e) => {
                        e.preventDefault()
                        goToPage(page ? parseInt(page) : 1)
                    }}>
                        <input className="fm cw fs12" type="Number" value={page} onChange={(e) => setPage(e.currentTarget.value)}></input>
                    </form> / {totalPages}
                </div>

                <button
                    onClick={() => goToPage(page + 1)}
                    disabled={page == totalPages}
                    className="px3 py1 rounded-xl shadow disabled:opacity-40"
                >
                    Next
                </button>
            </div>
        </div>
    );
}
